var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[_c('UiTab',{attrs:{"to":"/cards/mycollection"}},[_vm._v("My Collection")]),_c('UiTab',{attrs:{"to":"/cards/allcards"}},[_vm._v("View All")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }